<script setup>
/* eslint-disable */
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router';
import { useMarketsStore } from '@/stores/markets';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useFixtureStore } from '@/stores/fixture';
import { useDatesStore } from '@/stores/dates';
import { useFavouritesStore } from '@/stores/favourites';
import { useInitializeStore } from '@/stores/initialize';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import LiveFixtureDoubleMarketOverviewOdd from '@/components/pre_sports/highlights/LiveFixtureDoubleMarketOverviewOdd.vue';
import LiveFixtureDoubleSecondMarketOverviewOdd from '@/components/pre_sports/highlights/LiveFixtureDoubleSecondMarketOverviewOdd.vue';
import OverviewOdds from '@/components/pre_sports/highlights/OverviewOdds.vue'

const router = useRouter();
const marketsStore = useMarketsStore();
const liveSportsStore = useLiveSportsStore();
const fixtureStore = useFixtureStore();
const datesStore = useDatesStore();
const favouritesStore = useFavouritesStore();
const initializeStore = useInitializeStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

import commonSvgs from '@/assets/svgs/commonSvgs.json'
import JerseyIcon from '@/assets/svgs/jerseyIcon.vue';
const svg_data = ref(commonSvgs);

const props = defineProps({
	primary_overview_market: {
		required: true,
	},
	secondary_overview_market: {
		required: true,
	},
	fixture: {
		type: Object,
		required: true,
	},
	show_competition_region: {
		type: Boolean,
		default: false,
	}
});

const toggleFavourite = () => {
	favouritesStore.toggleFixture(props.fixture.id);
}

const goToFixture = () => {
	router.push({ name: 'pre-sports-fixturebook', params: { sport_id: props.fixture.sport_id, region_id: props.fixture.region_id, competition_id: props.fixture.competition_id, fixture_id: props.fixture.id } } )
}

const primaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(props.primary_overview_market.slug)) return [];

	return props.fixture.overview_markets[props.primary_overview_market.slug];
});

const secondaryOverviewMarketOdds = computed(() => {
	if (!props.fixture.overview_markets.hasOwnProperty(props.secondary_overview_market.slug)) return [];

	return props.fixture.overview_markets[props.secondary_overview_market.slug];
});

const isFavouite = computed(() => {
	if (favouritesStore.favouriteFixtureIds.includes(props.fixture.id)) return true;
})

</script>

<template>

	<div class="live-info-inner upcomimg_sport">

		<div class="no-live-teams" >
			<div class="region-info">
				<div v-if="show_competition_region && (props.fixture.region_name || props.fixture.competition_name)" class="fixture-competition-region">
					<img v-if="props.fixture.region_icon_url || props.fixture.region_icon" class="region-icon" :src="'/assets' + (props.fixture.region_icon_url || props.fixture.region_icon)" alt="" />
					<span>{{ props.fixture.region_name ? props.fixture.region_name + ' - ' : '' }}{{ props.fixture.competition_name }}</span>
				</div>
			</div>
			<div class="live-teams">
				<div class="star-stats" :class="{ 'competition-region': show_competition_region }">
					<div class="star-ico" :class="{ 'star-ico-small': props.fixture.stats_id && props.fixture.stats_id != '' && initializeStore.screenWidth > 767 }" @click="toggleFavourite">
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="11.143" viewBox="0 0 12 11.143">
							<path :style="{ fill: isFavouite ? 'var(--primary)' : '' }" id="Icon_ionic-ios-star" :class="`fixture-${fixture?.id}`" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" fill="var(--tab-gray)" />
						</svg>
					</div>
					<div v-if="props.fixture.stats_id && props.fixture.stats_id != '' && initializeStore.screenWidth > 767" class="statistics-button">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="var(--light-gray)" d="M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.8-7.2-16-16-16H16C7.2 64 0 71.2 0 80v336c0 17.7 14.3 32 32 32h464c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"/></svg>
					</div>
				</div>
				<div class="team-name" @click="goToFixture">

					<div class="team-inner">
						<span>{{ datesStore.preFixtureBookDate(props.fixture.start_datetime) }}</span>
						<div class="playing-teams">
							<img
								v-if="fixtureStore.getParticipantLogo(props.fixture.participant_logos)"
								class="playing-team-logo"
								:src="fixtureStore.getParticipantLogo(props.fixture.participant_logos).home" alt="#">
								<JerseyIcon v-if="fixtureStore.getParticipantJersey(props.fixture.jersey_colors)" :jerseyColor="fixtureStore.getParticipantJersey(props.fixture.jersey_colors).home" />
							<p>{{ props.fixture.participants ? fixture.participants[0] : '' }}</p>
						</div>
					</div>
					<div class="team-inner">
						<span>{{ datesStore.preFixtureBookTime(props.fixture.start_datetime) }}</span>
						<div class="playing-teams">
							<img
								v-if="fixtureStore.getParticipantLogo(props.fixture.participant_logos	)"
								class="playing-team-logo"
								:src="fixtureStore.getParticipantLogo(props.fixture.participant_logos).away" alt="#">
							<JerseyIcon v-if="fixtureStore.getParticipantJersey(props.fixture.jersey_colors)" :jerseyColor="fixtureStore.getParticipantJersey(props.fixture.jersey_colors).away" />
							<p v-if="!liveSportsStore.hasOneParticipant(fixture.sport_id) && !fixture.outright">
								{{ props.fixture.participants ? fixture.participants[1] : '' }}</p>
						</div>
					</div>

				</div>
			</div>


			<!-- <div @click="goToFixture" class="betting-total-mobile">
				<p><img src="/assets/icons/plus-bets.svg" alt="">&nbsp;{{ props.	fixture.odds_count }} {{$t('account.affiliate.bets')}}
				</p>
			</div> -->

		</div>

		<OverviewOdds v-if="primary_overview_market != null" :type="'primary'" :overview_market="primary_overview_market" :fixture="props.fixture" :fixture_overview_markets="props.fixture.overview_markets" :add_margin="show_competition_region"/>
		<OverviewOdds v-if="secondary_overview_market != null" :type="'secondary'" :overview_market="secondary_overview_market" :fixture="props.fixture" :fixture_overview_markets="props.fixture.overview_markets" :show_totals="true" :add_margin="show_competition_region"/>
		<!-- mobile-live icon start -->
		<div class="mobile-bottom-live">
			<div class="info-inner">
				<div class="upcoming-date-mobile">
					<span>{{ datesStore.preFixtureBookDate(props.fixture.start_datetime) }}</span>
					<span>{{ datesStore.preFixtureBookTime(props.fixture.start_datetime) }}</span>
					<span v-if="dateTimeSportFiltersStore.sort == 'time'"> | {{ props.fixture.region_name }} - {{ props.fixture.competition_name}} </span>
				</div>
				<div v-if="props.fixture.stats_id && props.fixture.stats_id != ''" class="statistics-button-mobile">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="var(--light-gray)" d="M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.8-7.2-16-16-16H16C7.2 64 0 71.2 0 80v336c0 17.7 14.3 32 32 32h464c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"/></svg>
				</div>

			</div>
			<div @click="goToFixture" class="betting-total-mobile">
				<p><img src="/assets/icons/plus-bets.svg" alt="" />&nbsp;{{ props.fixture.odds_count }} {{$t('account.affiliate.bets')}}</p>
			</div>
		</div>
		<!-- mobile-live icon start -->

	</div>


</template>
<style scoped>
@media (hover: hover) {
	.live-bet-dashboard .live-tab-info .live-info-outer .live-info-inner:nth-child(n+2):hover {
		background: var(--light-dark);
		border-radius: 3px;
	}
}
@media (hover: none) {
  .live-bet-dashboard .live-tab-info .live-info-outer .live-info-inner:nth-child(n+2):hover {
    background: none; /* Remove background */
    border-radius: none; /* Remove border-radius */
  }
}
@media screen and (min-width: 768px) {
	.live-bet-dashboard.round-games-main .live-tab-info .live-info-outer .live-info-inner .live-teams .team-name .team-inner p {
		max-width: 20ch;
	}
}

.playing-teams{
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: flex-start;
}

.playing-teams img {

	width: 1rem;
	height: 1rem;
	margin: 0 0.2rem;

}

.statistics-button {
	height: 14px;
	width: 14px;
}

.statistics-button-mobile {
	margin-top: -3px;
	height: 14px;
	width: 14px;
}

.star-stats {
	display: flex;
	gap: 0.5rem;
	flex-direction: column;
	height: 100%;
}

.star-ico-small {
	padding-bottom: 0px !important;
	height: 14px;
	width: 14px;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.upcomimg_sport {
		padding-right: 12px !important;
		padding-left: 12px !important;
	}
}

.live-bet-dashboard.round-games-main .live-tab-info .live-info-outer .live-info-inner .mobile-bottom-live {
	grid-template-columns: 2px 1fr auto;
}
.live-bet-dashboard.round-games-main .live-tab-info .live-info-outer .live-info-inner .mobile-bottom-live .info-inner {
	display: grid;
    grid-template-columns: 90% 10%;
    align-items: flex-start;
}

.statistics-button-mobile {
	align-self: anchor-center;
}

.fixture-competition-region {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 11px;
	color: var(--light-gray, #8a99ad);
	/* margin-bottom: 6px; */
	padding-bottom: 6px;
	/* border-bottom: 1px solid rgba(255, 255, 255, 0.12); */
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.fixture-competition-region .region-icon {
	width: 12px;
	height: 12px;
	object-fit: contain;
	flex-shrink: 0;
	border-radius: 2px;
}
html[dir="rtl"] .fixture-competition-region {
	padding-left: 0;
	padding-right: 58px;
}

/* .star-stats.competition-region {
	padding-top: 25px;
    justify-content: flex-start;
    gap: 0.8rem;
} */
</style>